
import React from "react";
import ProductPageTemplate from "@/components/ProductPageTemplate";
import { Brain, Database, Search, Lightbulb } from "lucide-react";

const DoraAI = () => {
  const benefits = [
    {
      title: "Instant Answers to Complex Questions",
      description: "Get immediate, data-backed insights on engagement trends, recognition patterns, and team performance without complex report building.",
      icon: <Search className="h-8 w-8" />
    },
    {
      title: "Actionable Recommendations",
      description: "Receive AI-powered suggestions for improving engagement, recognition practices, and team performance based on your organization's unique data.",
      icon: <Lightbulb className="h-8 w-8" />
    },
    {
      title: "Democratized Data Access",
      description: "Enable leaders at all levels to access the insights they need without requiring advanced analytics skills or complicated dashboards.",
      icon: <Database className="h-8 w-8" />
    },
    {
      title: "Continuous Learning",
      description: "Dora AI evolves with your organization, continuously learning from new data to provide increasingly relevant and personalized insights.",
      icon: <Brain className="h-8 w-8" />
    }
  ];

  const howItWorks = [
    {
      title: "Ask Natural Language Questions",
      description: "Simply type your question as you would ask a human analyst. Dora understands context, organizational structure, and the metrics that matter most to HR and people leaders.",
      image: "/lovable-uploads/bc45aff0-bfb1-4e56-a1d9-5c102edb829a.png"
    },
    {
      title: "Get Visual, Data-Backed Answers",
      description: "Receive clear, visualized responses that combine narrative explanations with supporting data in easy-to-understand charts and graphs.",
      image: "/lovable-uploads/dora-chart-response.png"
    },
    {
      title: "Implement Suggested Actions",
      description: "Turn insights into impact with Dora's practical recommendations for improving engagement, recognition practices, and team performance.",
      image: "/lovable-uploads/509f3d93-4acd-44aa-b232-0ddf2993d259.png"
    }
  ];

  return (
    <ProductPageTemplate
      title="Dora AI - Conversational Analytics for HR"
      description="Dora AI transforms how HR teams access and understand people data. Ask questions in plain language and get instant, AI-powered insights on engagement, recognition, and performance."
      keywords="HR analytics AI, employee engagement data, people analytics, HR data assistant, AI insights for HR, conversational analytics HR"
      heroTitle="Meet Dora: Your AI-Powered HR Analytics Assistant"
      heroDescription="Transform how you understand your people data. Ask questions in natural language and get instant, visual insights about engagement, recognition patterns, and team performance—no complex report building required."
      featureDescription="Dora AI is Assembly's conversational analytics assistant that makes HR data accessible to everyone. Instead of navigating complex dashboards or waiting for reports, simply ask Dora your questions in natural language. From recognition trends to engagement patterns, team performance to culture insights, Dora provides instant, visual answers backed by your organization's unique data."
      benefits={benefits}
      howItWorks={howItWorks}
      ctaText="Ready to revolutionize how you access HR insights?"
      ctaButtonText="Experience Dora AI Today"
      mainImage="/lovable-uploads/42f595b0-c093-4a8f-b25a-190b9e5ea2bd.png"
    />
  );
};

export default DoraAI;
